// extracted by mini-css-extract-plugin
var _1 = "RequestProfileHeaderFooter-moduleactionButtonWrapper__bW1LB";
var _2 = "RequestProfileHeaderFooter-moduleaddNewTextWrapper__T6ali";
var _3 = "RequestProfileHeaderFooter-modulebar__feayv";
var _4 = "RequestProfileHeaderFooter-modulecompactEdgeButton__zgkQ3";
var _5 = "RequestProfileHeaderFooter-modulecompactEdgeButtonWrapper__BVRfz";
var _6 = "RequestProfileHeaderFooter-modulecontainer__WAZiA";
var _7 = "RequestProfileHeaderFooter-modulefooter__qZVAB";
var _8 = "RequestProfileHeaderFooter-modulemoreButton__w2HAJ RequestProfileHeaderFooterMoreButton-moduleRequestProfileHeaderFooterMoreButton__DCUvb";
export { _1 as "actionButtonWrapper", _2 as "addNewTextWrapper", _3 as "bar", _4 as "compactEdgeButton", _5 as "compactEdgeButtonWrapper", _6 as "container", _7 as "footer", _8 as "moreButton" }
